module.exports = __webpack_public_path__ + "img/yota-vitrina-2.150c01c8.png";